import React from "react";
import { ContactInfo } from "../../types";

interface ManualContactInputProps {
  contactInfo: ContactInfo;
  setContactInfo: React.Dispatch<React.SetStateAction<ContactInfo>>;
  isLoadingRecipients: boolean;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

export const ManualContactInput: React.FC<ManualContactInputProps> = ({
  contactInfo,
  setContactInfo,
  isLoadingRecipients,
  onKeyDown
}) => {
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactInfo((prev: ContactInfo) => ({ ...prev, email: e.target.value, subChannel: "" }));
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactInfo((prev: ContactInfo) => ({ ...prev, phone: e.target.value }));
  };

  return (
    <div className="space-y-6">
      {isLoadingRecipients && (
        <div className="text-center text-muted-foreground">
          Loading contact information...
        </div>
      )}

      <div>
        <label htmlFor="email" className="text-sm font-medium text-foreground">
          Email Address
        </label>
        <input
          id="email"
          type="email"
          placeholder="your.email@example.com"
          value={contactInfo.email}
          onChange={handleEmailChange}
          onKeyDown={onKeyDown}
          className="mt-1 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>

      <div className="text-center">
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-border" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-background text-muted-foreground">OR</span>
          </div>
        </div>
      </div>

      <div>
        <label htmlFor="phone" className="text-sm font-medium text-foreground">
          Phone Number
        </label>
        <input
          id="phone"
          type="tel"
          placeholder="+1234567890"
          value={contactInfo.phone}
          onChange={handlePhoneChange}
          onKeyDown={onKeyDown}
          className="mt-1 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>
    </div>
  );
};